import { jsx } from 'react/jsx-runtime';
import { forwardRef, useContext, useCallback } from 'react';
import classNames from 'classnames';
import { InputContext } from '../Input/Input.Context/Input.Context.es.js';

const TextareaInner = /*#__PURE__*/ forwardRef(({ className, numLines = 4, resizable = true, onChange, error, label, value, ...rest }, ref)=>{
    const { id, inputLabelId, inputMessageId, disabled, loading, placeholder, readOnly } = useContext(InputContext);
    const handleChange = useCallback((ev)=>{
        onChange?.(ev);
    }, [
        onChange
    ]);
    return jsx("textarea", {
        ref: ref,
        "aria-describedby": inputMessageId,
        "aria-labelledby": inputLabelId,
        className: classNames(`input textarea lines-${numLines}`, {
            resizable
        }),
        "data-testid": "textarea",
        disabled: disabled || loading,
        id: id,
        onChange: handleChange,
        placeholder: placeholder,
        readOnly: readOnly,
        value: value,
        ...rest
    });
});
TextareaInner.displayName = 'Textarea.Inner';

export { TextareaInner, TextareaInner as default };
//# sourceMappingURL=Textarea.Inner.es.js.map
